import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Box, Copy } from '@elparking/components'
import { Star } from '../Icons'

const Recommended = ({ backgroundColor }) => <Box background={backgroundColor} display='inline-flex' padding='4px 6px'>
    <Star color='accent'/>
    <Copy ml='4px' textWrap='no-wrap' as='span' padding='0px' fontSize='xxSmall' fontWeight='book' fontColor='accent'>
        <FormattedMessage defaultMessage='Recomendado' />
    </Copy>
</Box>

Recommended.propTypes = {
    backgroundColor: PropTypes.string,
}

Recommended.defaultProps = {
    backgroundColor: 'accent10',
}

export default Recommended
